import { createAuthClient } from 'better-auth/client';
import { adminClient } from 'better-auth/client/plugins';
import { createAccessControl } from 'better-auth/plugins/access';

const ac = createAccessControl({
  clientPortal: ['use', 'staff'],
  csm: ['use', 'all-routes'],
  highlighter: ['use'],
} as const);

const roles = {
  admin: ac.newRole({
    clientPortal: ['use', 'staff'],
    csm: ['use', 'all-routes'],
    highlighter: ['use'],
  }),
  client: ac.newRole({ clientPortal: ['use'], highlighter: ['use'] }),
  // Heimdall's default role; Better Auth also reads an empty role as `user`.
  user: ac.newRole({ highlighter: ['use'] }),
  warehouse: ac.newRole({ csm: ['use'], highlighter: ['use'] }),
};

// Checks roles locally; it never sends a request, so it needs no base URL.
const permissionClient = createAuthClient({ plugins: [adminClient({ ac, roles })] });

type HeimdallPermissions = Parameters<
  typeof permissionClient.admin.checkRolePermission
>[0]['permissions'];

/** Whether a Heimdall role grants every permission asked for. */
export function hasHeimdallPermission(
  role: string | null | undefined,
  permissions: HeimdallPermissions,
): boolean {
  return permissionClient.admin.checkRolePermission({
    permissions,
    // Heimdall stores roles comma-joined and `hasPermission` splits them at run time.
    role: role as keyof typeof roles,
  });
}
